import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'relative flex flex-col items-center justify-center gap-4 rounded-md border border-dashed border-[var(--color-hairline-strong)] bg-[var(--color-paper-dim)] px-6 py-16 text-center',
        className,
      )}
    >
      {icon && (
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--color-paper)] text-[var(--color-ink-muted)] ring-1 ring-[var(--color-hairline-strong)]">
          {icon}
        </div>
      )}
      <div className="space-y-1">
        <h3 className="font-display text-lg font-semibold text-[var(--color-ink)]">
          {title}
        </h3>
        {description && (
          <p className="max-w-md text-sm text-[var(--color-ink-muted)]">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}
